import { useRef, useCallback } from 'react';

/**
 * Manages scroll behavior and focus for the message list and footer input.
 * Provides refs and helper functions for scroll and focus management.
 * 
 * @returns {Object} { footerFocusRef, listScrollApiRef, scrollToBottom, focusFooterInput }
 */
const useMessageScrollManagement = () => {
    const footerFocusRef = useRef(null);
    const listScrollApiRef = useRef(null);

    const scrollToBottom = useCallback(() => {
        try {
            if (listScrollApiRef.current && typeof listScrollApiRef.current.scrollToBottom === 'function') {
                listScrollApiRef.current.scrollToBottom();
            }
        } catch (e) { }
    }, []);

    const focusFooterInput = useCallback(() => {
        try {
            footerFocusRef.current && footerFocusRef.current();
        } catch (e) { }
    }, []);

    return {
        footerFocusRef,
        listScrollApiRef,
        scrollToBottom,
        focusFooterInput
    };
};

export default useMessageScrollManagement;
